const colors = {
    background: '#f4f4f7',

    primary: '#a9cf46',
    primaryDark: '#779e08',
    primaryLight: '#ddff77',
    textOnPrimary: '#000000',

    accent: '#3D4955',
    accentDark: '#16222c',
    accentLight: '#687481',
    textOnAccent: '#ffffff',

    callToAction: '#3498db',

    textPrimaryDark: 'rgba(0, 0, 0, 0.87)', // 87%
    textSecondaryDark: 'rgba(0, 0, 0, 0.54)', // 54%
    textDisabledDark: 'rgba(0, 0, 0, 0.38)', // 38%
    textHintDark: 'rgba(0, 0, 0, 0.38)', // 38%
    dividerDark: 'rgba(0, 0, 0, 0.12)', // 12%

    textPrimaryLight: 'rgb(255, 255, 255)', // 100%
    textSecondaryLight: 'rgba(255, 255, 255, 0.7)', // 70%
    textDisabledLight: 'rgba(255, 255, 255, 0.5)', // 50%
    textHintLight: 'rgba(255, 255, 255, 0.5)', // 50%
    dividerLight: 'rgba(255, 255, 255, 0.24)', // 24%

    tagBackground: '#dddddd',

    successColor: '#00A300',
    errorColor: '#ff0000',

    pendingOrderSubscription: '#FFA41C',
    inactiveOrderSubscription: '#FF7676',

    transparent: 'rgba(0, 0, 0, 0)',
};

export const GENERAL_CHART_COLORS = ['#70D6FF', '#FF70A6', '#FFCC4D', '#C3E600', '#FF9770'];
export const GENDER_CHART_COLORS = ['#FF0000', '#0088FE', '#b3b3b3'];

export const getColorContrastYIQ = hexcolor => {
    if (!hexcolor) return '#000000';
    let color;
    switch (hexcolor.length) {
        case 7: // #ff00ff
            color = hexcolor.substr(1);
            break;
        case 4: // #f0f
            color = hexcolor.substr(1, 1).repeat(2)
                + hexcolor.substr(2, 1).repeat(2) + hexcolor.substr(3, 1).repeat(2);
            break;
        default:
            return '#ffffff';
    }
    const r = parseInt(color.substr(0, 2), 16);
    const g = parseInt(color.substr(2, 2), 16);
    const b = parseInt(color.substr(4, 2), 16);
    const yiq = ((r * 299) + (g * 587) + (b * 114)) / 1000;
    return (yiq >= 128) ? '#000000' : '#ffffff';
};

export default colors;
